module.exports = __webpack_public_path__ + "img/uy.06c0b922.svg";